import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=9e067556&scoped=true"
import script from "./InvoiceItem.vue?vue&type=script&lang=js"
export * from "./InvoiceItem.vue?vue&type=script&lang=js"
import style0 from "./InvoiceItem.vue?vue&type=style&index=0&id=9e067556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e067556",
  null
  
)

export default component.exports